import * as queries from './queries'
import * as mutations from './mutations'

export const Employees = {
  mutations: {
    ...mutations
  },
  queries: {
    ...queries
  }
}
